module.exports = __webpack_public_path__ + "business-mann-e8796b2f.webp";